<template>
  <div class="feedback-box content h-100">
    <div v-if="comments.length">
      <tab-comment
        v-for="(comment, index) in comments"
        :key="comment.id"
        ref="comments"
        :index="index"
        :comment="comment"
        :comment-loading="commentLoading"
        :class="{ comment: true, active: activeHighlightIndex === index }"
        @click.native="handleClick(index)"
        @update="$emit('updateComment', $event)"
        @delete="$emit('deleteComment', $event)"
      />
    </div>

    <div v-else class="d-flex h-100 p-5">
      <div class="m-auto">
        <empty-state
          key="empty"
          :title="$t('essays.noCommentsYet')"
          :description="$t('essays.highlightToComment')"
          class="m-auto"
          data-testid="empty-state"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TabComment from "@/components/essay/comments/tab_comment.vue";
import EmptyState from "@/components/global/empty_state.vue";

export default {
  components: {
    TabComment,
    EmptyState,
  },

  props: {
    comments: {
      type: Array,
      required: true,
    },

    activeHighlightIndex: {
      type: Number,
      default: -1,
    },

    commentLoading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    comments: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          const highlights = this.comments.map((comment, index) => {
            return {
              range: comment.ranges,
              highlightIndex: index + 1,
              showHighlightIndex: true,
              refComponent: this.$refs.comments?.[index],
              color: "var(--colors-secondary-100)",
              backgroundColor: "var(--colors-secondary-100)",
            };
          });

          this.$emit("updateHighlights", highlights);
        });
      },
    },
  },

  methods: {
    handleClick(index) {
      this.$emit("updateActiveHighlightIndex", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt--4 {
  margin-top: -1rem;
}
</style>
